/**
 * Spec 078: Supported brand locales (frontend copy).
 *
 * Keep in sync with src/discovery/locale-map.ts SUPPORTED_LOCALES.
 * Do NOT import server code from client — Vite client/server boundary.
 */

export const SUPPORTED_LOCALES = [
  { value: 'en-US', label: 'English (United States)' },
  { value: 'da-DK', label: 'Dansk (Danmark)' },
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]['value'];
